import { render, staticRenderFns } from "./headfee-add.vue?vue&type=template&id=254cd372&"
import script from "./headfee-add.vue?vue&type=script&lang=ts&"
export * from "./headfee-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports